import { NoContentPlaceholder } from "../../../components/NoContentPlaceholder.js";
import { useRecentRecords } from "../hooks/useRecentRecords.js";
import { RecordsHorizontalScroll } from "./RecordsHorizontalScroll/RecordsHorizontalScroll.js";
import "react";
import { Icon } from "@therms/atalaya";
import { jsx } from "react/jsx-runtime";
import { MdTimerOff } from "react-icons/md";
//#region src/modules/Records/shared/RecentRecords.tsx
function RecentRecords({ onClick, showNoResults = true }) {
	const { loading, recentRecords, removeRecentRecord } = useRecentRecords();
	if (!showNoResults && !recentRecords) return null;
	return /* @__PURE__ */ jsx("div", {
		className: "mt-sm",
		children: /* @__PURE__ */ jsx(RecordsHorizontalScroll, {
			data: recentRecords ?? [],
			noContentElement: /* @__PURE__ */ jsx(NoContentPlaceholder, {
				icon: /* @__PURE__ */ jsx(Icon, {
					Icon: MdTimerOff,
					size: "xxl"
				}),
				children: "No recent Records"
			}),
			loading,
			onClick,
			onRemove: removeRecentRecord
		})
	});
}
//#endregion
export { RecentRecords };

//# sourceMappingURL=RecentRecords.js.map